import { AxiosRequestConfig } from 'axios'

import { ParametersDownload } from './types'

const getStores = ({ startDate, endDate, storeId }: ParametersDownload): AxiosRequestConfig => {
  const params = {
    ...(startDate ? { startDate: startDate.toISOString() } : {}),
    ...(endDate ? { endDate: endDate.toISOString() } : {}),
    ...(storeId ? { storeId } : {}),
  }

  return {
    url: 'dashboard/stores',
    method: 'GET',
    params,
  }
}

export { getStores }
